import { AfterViewInit, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

declare var lottie: any;

@Component({
  selector: 'app-order-complete-dialog',
  templateUrl: './order-complete-dialog.component.html',
  styleUrls: ['./order-complete-dialog.component.scss'],
})
export class OrderCompleteDialogComponent implements AfterViewInit {
  heading: string;
  message: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public _data: any,
    public _matDialogRef: MatDialogRef<OrderCompleteDialogComponent>
  ) {
    this.heading = _data?.heading || 'Order Completed!';
    this.message = _data?.message || 'Your order has been completed successfully.';
  }

  ngAfterViewInit(): void {
    if (typeof lottie !== 'undefined') {
      lottie.loadAnimation({
        container: document.getElementById('success-lottie'),
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: 'assets/Success.json',
      });
    }
  }

  onClose(): void {
    this._matDialogRef.close();
  }
}

